module.exports = __webpack_public_path__ + "static/media/main_logo.e8a54633.svg";